import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GettingStartedSectionComponent } from '../../sections/client-initiated-loan/getting-started/getting-started-section.component';
import { AboutYouSectionComponent } from '../../sections/pre-approval/about-you/about-you-section.component';
import { PropertySectionComponent } from '../../sections/pre-approval/property/property-section.component';
import { IncomeAndAssetsSectionComponent } from '../../sections/client-initiated-loan/income-and-assets/income-and-assets-section.component';
import { SubmitSectionComponent } from '../../sections/client-initiated-loan/submit/submit-section.component';
import { StepSection } from '../../../enums/step-section.enum';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StepperContextService, StepperMode } from '../../../services/stepper-context.service';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { StepperAnswersService } from '../../../services/stepper-answers.service';
import { GettingStartedSteps } from '../../../enums/getting-started-steps.enum';
import { AboutYouSteps } from '../../../enums/about-you-steps.enum';
import { CurrentAddressInputs } from '../../sections/pre-approval/about-you/steps/borrower-current-address/borrower-current-address.component';
import { CitizenshipOptions } from '../../sections/client-initiated-loan/about-you/steps/borrower-citizenship/borrower-citizenship.component';
import { MilitaryOptions } from '../../sections/pre-approval/about-you/steps/borrower-military/borrower-military.component';
import { PropertySteps } from '../../../enums/property-steps.enum';
import { PreApprovalSectionComponent } from '../../sections/pre-approval/pre-approval/pre-approval-section.component';

@Component({
  selector: 'lgv-pre-approval-stepper',
  standalone: true,
  imports: [CommonModule, GettingStartedSectionComponent, AboutYouSectionComponent, PropertySectionComponent, PreApprovalSectionComponent],
  templateUrl: './pre-approval-stepper.component.html',
  styleUrls: ['./pre-approval-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreApprovalStepperComponent {

  @Input() agentIdParam: string;
  @Input() queryParams;
  @Input() loanInfo;
  StepSection = StepSection

  public currentSection: StepSection = StepSection.AboutYou
  public specificStep = ''

  constructor(
    public dialog: MatDialog,
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    @Optional() public dialogRef: MatDialogRef<PreApprovalStepperComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute
  ) {
    if (data) {
      this.contextService.isDialog = true
      this.contextService.agentId = this.data.agentId
      if (Object.keys(data.clientInfo).length > 0) {
        this.contextService.mode = StepperMode.ClientMode
        this.answerService.loadClientInfo(data.clientInfo, data.clientAddress)
      }
      if (data.fromQuickPricer) {
        this.answerService.loadDataFromQuickPricer(data.fromQuickPricer)
      }
    }
  }
  ngOnInit() {
    if (!this.contextService.isDialog) {
      this.contextService.agentId = (this.contextService.agentId === '')
        ? this.agentIdParam
        : '';
    }
    this.route.queryParams.pipe(first()).subscribe(queryParams => {
      const params = { ...queryParams };
      this.queryParams = params as Record<string, string>
      if ('clientExternalId' in this.queryParams) {
        this.contextService.clientExternalId = this.queryParams.clientExternalId
        delete this.queryParams.clientExternalId;
      }
      this.answerService.prepopulateQueryParams(this.queryParams)
    });
    this.prepopulateLoanInfo(this.loanInfo)
    this.contextService.isPreApproval = true
  }

  onClose(): void {
    this.dialogRef?.close();
  }

  goToSection(event) {
    console.log('here x')
    this.specificStep = event[1]
    this.currentSection = event[0]
  }

  prepopulateLoanInfo(loanInfo) {
    if (loanInfo.borrowers[0].currentAddress){
      const ownedAddressMappedInputs: Partial<Record<string, string>> = {};
      if (loanInfo.borrowers[0].currentAddress.street !== '') {
        ownedAddressMappedInputs[CurrentAddressInputs.Address1] = loanInfo.borrowers[0].currentAddress.street;
      }
      if (loanInfo.borrowers[0].currentAddress.city !== '') {
        ownedAddressMappedInputs[CurrentAddressInputs.City] = loanInfo.borrowers[0].currentAddress.city;
      }
      if (loanInfo.borrowers[0].currentAddress.state !== '') {
        ownedAddressMappedInputs[CurrentAddressInputs.State] = loanInfo.borrowers[0].currentAddress.state;
      }
      if (loanInfo.borrowers[0].currentAddress.zipCode !== '') {
        ownedAddressMappedInputs[CurrentAddressInputs.Zip] = loanInfo.borrowers[0].currentAddress.zipCode;
      }
  
      if (Object.keys(ownedAddressMappedInputs).length > 0) {
        this.answerService.setAnswer(AboutYouSteps.BorrowerCurrentAddress, ownedAddressMappedInputs);
      }
    }

    if (loanInfo.borrowers[0].citizenship && loanInfo.borrowers[0].citizenship.name !== '') {
      this.answerService.setAnswer(AboutYouSteps.BorrowerCitizenship, loanInfo.borrowers[0].citizenship.name);
    }
    if (loanInfo.borrowers[0].isMilitary) {
      loanInfo.borrowers[0].isMilitary ? this.answerService.setAnswer(AboutYouSteps.BorrowerMilitary, MilitaryOptions.Yes) :
        this.answerService.setAnswer(AboutYouSteps.BorrowerMilitary, MilitaryOptions.No)
    }

    if (loanInfo.occupancy.name && loanInfo.occupancy.name !== '') {
      this.answerService.setAnswer(PropertySteps.PropertyUsage, loanInfo.occupancy.name);
    }
  }

  ngOnDestroy(){
    this.answerService.clear()
  }
}
